import React from 'react';

const magnifyingGlass = (stroke) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.08333 16.4167C13.1334 16.4167 16.4167 13.1334 16.4167 9.08333C16.4167 5.03325 13.1334 1.75 9.08333 1.75C5.03325 1.75 1.75 5.03325 1.75 9.08333C1.75 13.1334 5.03325 16.4167 9.08333 16.4167Z"
        stroke={stroke ? stroke.stroke : '#C4C4C4'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.25 18.25L14.2625 14.2625"
        stroke={stroke ? stroke.stroke : '#C4C4C4'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default magnifyingGlass;
